import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleDamageFaultEnum } from '../enums/vehicle-damage-fault.enum';
import { VehicleDamageRecordCategoryEnum } from '../enums/vehicle-damage-record-category.enum';
import { VehicleDamageSeverityEnum } from '../enums/vehicle-damage-severity.enum';
import { VehicleDamageStatusEnum } from '../enums/vehicle-damage-status.enum';
import { VehicleDamageTypeEnum } from '../enums/vehicle-damage-type.enum';

import { VehicleDamageLinksDto } from './vehicle-damage-links.dto';

/**
 * Vehicle damage DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_DAMAGE)
export class VehicleDamageSearchDto extends BaseSearchDto {
	code!: string;
	status!: VehicleDamageStatusEnum;
	recordCategory!: VehicleDamageRecordCategoryEnum;
	type?: VehicleDamageTypeEnum | null;
	fault?: VehicleDamageFaultEnum | null;
	severity?: VehicleDamageSeverityEnum | null;
	reportedAt!: Date;
	vehicleLicensePlate?: string | null;
	vehicleVin?: string | null;
	rentalAgreementDocumentNumber?: string | null;
	links?: VehicleDamageLinksDto | null;
	files?: FileDto[] | null;
	tags?: TagListDto[] | null;
}
